<template>
  <b-container>
    <h4 class="text-center">Your account requires a password change</h4>
    <b-form @submit.prevent="changePassword">
      <!-- password -->
      <b-form-group 
        id="passwordInputGroup" 
        label="New password" 
        label-for="passwordInput"
        :invalid-feedback="passwordStrengthMessage">
        <b-form-input 
          :state="passwordStrongEnough"
          id="passwordInput" 
          type="password" 
          v-model="newPW" 
          placeholder="enter a new password">
        </b-form-input>
      </b-form-group>
      <!-- confirm password -->
      <b-form-group 
        id="ConfirmPasswordInputGroup" 
        label="Re-enter new password" 
        label-for="ConfirmPasswordInput"
        :invalid-feedback="invalidFeedbackConfirm">
        <b-form-input 
          :state="validateConfirm"
          id="ConfirmPasswordInput" 
          type="password" 
          v-model="confirmNewPW" 
          placeholder="confirm new password">
        </b-form-input>
      </b-form-group>
      <b-button
        block
        type="submit"
        :disabled="!passwordStrongEnough || !validateConfirm || waiting"
        variant="outline-primary" 
        size="lg">
        Change password <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
      </b-button>
    </b-form>
  </b-container>
</template>

<script>
import { authService } from '../_services';
import { checkPasswordStrength } from '../_helpers'

export default {
  data() {
    return {
      waiting: false,
      newPW: '',
      confirmNewPW: '',
      failureMessage: null
    }
  },
  methods: {
    changePassword() {
      this.waiting = true
      let vm = this
      authService.forcedPasswordChange(this.newPW)
      .then((response) => {
        vm.waiting = false
        console.log(response)
        vm.$bvModal.msgBoxOk(response.data)
        .then(() => {
          vm.$router.push({path: '/'})
        })
      })
      .catch((response) => {
        this.waiting = false
      })
    }
  },
  computed: {
    passwordStrengthMessage() {
      return checkPasswordStrength(this.newPW)
    },
    passwordStrongEnough() {
      return checkPasswordStrength(this.newPW) === ''
    },
    newPasswordsMatch() {
      return this.newPW === this.confirmNewPW
    },
    validateConfirm() {
      return this.confirmNewPW !== '' && this.newPasswordsMatch
    },
    // invalidFeedbackNew() {
    //   if (this.newPW === '') {
    //     return 'cannot have blank fields'
    //   }
    //   return 'passwords must match'
    // },
    invalidFeedbackConfirm() {
      if (this.confirmNewPW === '') {
        return 'cannot have blank fields'
      }
      return 'passwords must match'
    },
  }
}
</script>

<style lang="scss" scoped>

</style>

E-g12TSNQwCqdo


// WEBPACK FOOTER //
// src/components/TempPWChange.vue